const VEHICLE_ASSIGNMENT_COMPANY_IDS = [226, 265];

export const canAccessVehicleAssignment = (companyId) =>
  (typeof companyId === "number" || typeof companyId === "string") &&
  VEHICLE_ASSIGNMENT_COMPANY_IDS.includes(Number(companyId));

export const isVehicleAssignmentPath = (path = "") =>
  /^\/dashboard\/(vehicle-assignment|site-directory)(\/|$)/i.test(path);
